export interface RelatedProductCandidate {
  id: number;
  name: string;
}

export const relatedProductCandidateFromResponse = (
  responseData: any,
): RelatedProductCandidate => ({
  id: responseData.id,
  name: responseData.name,
});
